module.exports = __webpack_public_path__ + "img/speedometer.84ad28f7.svg";